import SlimSelect from "slim-select";

interface Address {
    label: string;
    score: number;
}

export async function searchAddress(query: string): Promise<Address[]> {
    try {
        // Appel à l'API avec la requête utilisateur
        const response = await fetch(`${window.Openscop.URL_API_ADRESSE}?q=${encodeURIComponent(query)}&limit=10`);
        if (!response.ok) {
            throw new Error("Erreur de l'API");
        }
        // Transformation des données reçues
        const data = await response.json();
        return data.features.map((feature: any) => ({
            label: feature.properties.label,
            score: feature.properties.score,
            citycode: feature.properties.citycode,
            postcode: feature.properties.postcode,
            district: feature.properties.district,
        }));
    } catch (error) {
        if(window.Openscop.debug) console.error("Erreur lors de la recherche d'adresse:", error);
        throw error;
    }
}

// Fonction pour afficher les suggestions d'adresses
export function displaySuggestions(addresses: Address[], input_id: string, commune_input_id: string = "", departement_input_id: string = "") {
    const suggestionsContainer = document.getElementById('suggestions');
    if (!suggestionsContainer) return;
    const departementSelect = document.getElementById(departement_input_id) as HTMLSelectElement;
    const communeSelect = document.getElementById(commune_input_id) as HTMLSelectElement;

    // Efface les suggestions précédentes
    suggestionsContainer.innerHTML = '';

    // Ajoute les nouvelles suggestions
    addresses.forEach(address => {
        const div = document.createElement('div');
        div.className = 'suggestion-item';
        div.textContent = address.label;

        // Ajoute un gestionnaire de clic pour chaque suggestion
        div.addEventListener('click', async () => {
            // Désactive temporairement le gestionnaire d'événement 'change' du département
            departementSelect?.removeEventListener('change', departementChangeHandler);

            // Met à jour la valeur de l'input avec l'adresse sélectionnée
            (document.getElementById(input_id) as HTMLInputElement).value = address.label;
            suggestionsContainer.innerHTML = ''; // Efface les suggestions après sélection

            // Récupère et met à jour la commune et le département si les IDs sont fournis
            if (commune_input_id && departement_input_id && address.citycode) {
                try {
                    const response = await fetch(`/administrative_division/ajax/get_commune_by_code_insee/?code_insee=${address.citycode}`);
                    if (!response.ok) throw new Error("Erreur lors de la récupération de la commune");
                    const data = await response.json();
                    if (data.error) {
                        if(window.Openscop.debug) console.error(data.error);
                    } else {

                        if (departementSelect) {
                            // Définit l'option sélectionnée en fonction de departement_pk
                            departementSelect.slim?.setSelected(String(data.departement_pk));

                            // Charge les communes et met à jour la sélection après le chargement
                            await loadCommunes(data.departement_pk, communeSelect);

                            if (communeSelect) {
                                // Sélectionne la commune correspondante dans la liste des options
                                Array.from(communeSelect.options).forEach(option => {
                                    option.selected = option.value === String(data.commune_pk);
                                });
                                // Mise à jour de la sélection dans SlimSelect
                                communeSelect.slim?.setSelected(String(data.commune_pk));
                            }
                        }
                    }
                } catch (error) {
                    if(window.Openscop.debug) console.error("Erreur lors de l'appel de l'API :", error);
                } finally {
                    // Réactive le gestionnaire d'événements après la sélection
                    departementSelect?.addEventListener('change', departementChangeHandler);
                }
            }
        });
        suggestionsContainer.appendChild(div);
    });
}


// Fonction pour afficher un message d'erreur
export function displayError(message: string) {
    const errorElement = document.getElementById('error');
    if (errorElement) {
        errorElement.textContent = message;
    }
}

// Fonction pour effacer le message d'erreur
export function clearError() {
    const errorElement = document.getElementById('error');
    if (errorElement) {
        errorElement.textContent = '';
    }
}


// Fonction pour charger les communes par département
let currentDepartementId: string | null = null;  // Suivi de l'ID du département actuel

export async function loadCommunes(departementId: string, communeField: HTMLSelectElement): Promise<void> {
    // Si le département est déjà le même, on ne fait rien
    if (currentDepartementId === departementId) {
        return;
    }

    // Mettre à jour le département actuel
    currentDepartementId = departementId;

    return new Promise((resolve, reject) => {
        fetch(`/administrative_division/ajax/commune/?field=commune&parent_field=departement&parent_value=${departementId}`)
            .then(response => {
                if (!response.ok) {
                    reject('Erreur lors de la récupération des communes');
                }
                return response.json();
            })
            .then(data => {
                // Efface les options actuelles
                communeField.innerHTML = '<option value="">--------</option>';

                // Ajoute les nouvelles options en utilisant le format de données de la réponse
                data.forEach(commune => {
                    const option = document.createElement('option');
                    option.value = commune[0];  // ID de la commune
                    option.textContent = commune[1];  // Nom de la commune
                    communeField.appendChild(option);
                });

                // Réinitialise Slim Select en le détruisant puis en le recréant
                if (communeField.slim) {
                    communeField.slim.destroy();  // Supprime l'instance actuelle de Slim Select
                }
                communeField.slim = new SlimSelect({
                    select: communeField
                });

                resolve();
            })
            .catch(error => {
                reject(error);
            });
    });
}



export function departementChangeHandler(event: Event) {
    const departementInput = event.target as HTMLSelectElement;
    const departementId = departementInput.value;
    if (departementId) {
        const communeInput = document.getElementById('id_commune') as HTMLSelectElement;  // Remplacez 'commune_id' par l'ID réel
        if (communeInput) {
            loadCommunes(departementId, communeInput);
        }
    } else {
        // Si aucun département n'est sélectionné, on efface les options de commune
        const communeInput = document.getElementById('id_commune') as HTMLSelectElement;
        if (communeInput) {
            communeInput.innerHTML = '<option value="">Sélectionnez une commune</option>';
        }
    }
}